<template >
  <div>
    <div class="container resultsShow">
    <div class="firstRowBox">
      <div class="firstRow">
        <h1>
          <span class="icon"></span><span class="H1title">成果展示</span>
          <span class="icon1"></span>
          <!-- <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span> -->
          <el-button
            class="viewMoreBtn"
            type="danger"
            size="small"
            plain
            @click="doMore(2038, 1)"
            >查看更多</el-button
          >
        </h1>
        <div class="white-background">
          <el-row class="bigNews" :gutter="24">
            <el-col :sm="12">
              <el-image
                class="news-image1"
                fit="cover"
                :src="getFirstPic(bigNews.content)"
                @click="viewNews(bigNews)"
              >
                <div slot="error" class="default-img">
                  <i class="iconfont iconjiaocaizhanwei"></i>
                </div>
              </el-image>
            </el-col>
            <el-col :sm="12">
              <div class="title" @click="viewNews(bigNews)">
                {{ bigNews.title }}
              </div>
              <div class="time" @click="viewNews(bigNews)">
                {{ timeFormat(bigNews.publish_time) }}
              </div>
              <div class="content" @click="viewNews(bigNews)">
                {{ replaceTag(bigNews.content) }}
              </div>
            </el-col>
          </el-row>
          <div class="newsBorder"></div>
          <el-row :gutter="24">
            <el-col :sm="12" v-for="(item, index) in schoolList" :key="item.id">
              <div
                class="news-item"
                :class="{ first: index === 0, second: index === 1 }"
                @click="viewNews(item)"
              >
                <span class="iconfont icontuwen"></span>
                <span class="time1">{{ timeFormat(item.publish_time) }}</span>
                <div class="title1">{{ item.title }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="mobile bgBox1"></div>
    <div class="secondRowBox">
      <div class="secondRow">
        <h1>
          <span class="icon"></span><span class="H1title">教师成果</span>
          <span class="icon1"></span>
          <!-- <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span> -->
          <el-button
            class="viewMoreBtn"
            type="danger"
            size="small"
            plain
            @click="doMore(2039, 2)"
            >查看更多</el-button
          >
        </h1>
        <div class="white-background">
          <el-row>
            <el-col
              :sm="24"
              v-for="(item, index) in teaList"
              :key="item.id"
              class="news-item1"
              :class="{ first: index === 0 }"
              @click.native="viewNews(item)"
            >
              <span class="cirBox"></span>
              <span class="teaTitle"> {{ item.title }}</span>
              <div class="teaContent">{{ replaceTag(item.content) }}</div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="mobile bgBox1"></div>
      <div class="thirdRow">
        <h1>
          <span class="icon"></span><span class="H1title">光影师大</span>
          <span class="icon1"></span>
          <!-- <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span> -->
          <el-button
            class="viewMoreBtn"
            type="danger"
            size="small"
            plain
            @click="doMore(2040, 0)"
            >查看更多</el-button
          >
        </h1>
        <div class="white-background1">
          <el-row :gutter="screenWidth > 992 ? 24 : 15">
            <el-col
              :sm="6"
              :xs="12"
              v-for="(item, index) in courseList"
              :key="item.id"
              :class="{ topMargin: index > 3 }"
            >
              <div
                class="course-item can-click has-hover hover-bigger"
                @click="viewNews(item)"
              >
                <div class="cover-wrapper">
                  <el-image
                    class="cover"
                    fit="cover"
                    :src="getUnkownPic(item.content)"
                  >
                    <div slot="error" class="default-img">
                      <i class="iconfont iconjiaocaizhanwei"></i>
                    </div>
                  </el-image>
                </div>
                <div class="course-info">
                  <div class="title2">{{ item.title }}</div>
                  <div class="time2">{{ timeFormat(item.publish_time) }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="mobile bgBox1"></div>
      <!-- <div class="lastRow">
        <h1>
          <span class="icon"></span><span class="H1title">党建活动</span>
          <span class="icon1"></span>
          <span class="H1title1 pc">建设优势突出、特色鲜明的高水平大学</span>
          <el-button
            class="viewMoreBtn"
            type="danger"
            size="small"
            plain
            @click="doMore(2000, 1)"
            >查看更多</el-button
          >
        </h1>
        <div class="white-background">
          <el-row class="bigNews" :gutter="24">
            <el-col :sm="12">
              <el-image
                class="news-image1"
                fit="cover"
                :src="getFirstPic(bigNews1.content)"
                @click="viewNews(bigNews1)"
              >
                <div slot="error" class="default-img">
                  <i class="iconfont iconjiaocaizhanwei"></i>
                </div>
              </el-image>
            </el-col>
            <el-col :sm="12">
              <div class="title" @click="viewNews(bigNews1)">
                {{ bigNews1.title }}
              </div>
              <div class="time" @click="viewNews(bigNews1)">
                {{ timeFormat(bigNews1.modifyTime) }}
              </div>
              <div class="content" @click="viewNews(bigNews1)">
                {{ replaceTag(bigNews1.content) }}
              </div>
            </el-col>
          </el-row>
          <div class="newsBorder"></div>
          <el-row :gutter="24">
            <el-col :sm="12" v-for="(item, index) in activeList" :key="item.id">
              <div
                class="news-item"
                :class="{ first: index === 0, second: index === 1 }"
                @click="viewNews(item)"
              >
                <span class="iconfont icontuwen"></span>
                <span class="time1">{{ timeFormat(item.modifyTime) }}</span>
                <div class="title1">{{ item.title }}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div> -->
    </div>
    </div>
    <div class="firstBgBox pc"></div>
  </div>
</template>
<script>
import { articleList } from "@/api/crmApi.js";
import config from "../config.js";
import util from "@/libs/util.js";
export default {
  data() {
    return {
      id: null,
      schoolList: [],
      bigNews: [],
      teaList: [],
      courseList: [],
      bigNews1: [],
      activeList: [],
        screenWidth: 1000,
    };
  },
  created() {
    this.init();
    this.screenWidth = document.documentElement.clientWidth;
    window.onresize = () => {
      this.screenWidth = document.documentElement.clientWidth;
    };
  },
  methods: {
    init() {
      articleList({ orgId: config.orgId,menu_pid:2037,menu_id:2038,pageSize:5,pageNum:1 })
      .then(res=>{
        this.bigNews = res.result.list[0] ? res.result.list[0] : {};
        this.schoolList = res.result.list.slice(1);
      })
      .catch(res=>{
        console.log(res);
      })
       articleList({ orgId: config.orgId,menu_pid:2037,menu_id:2039,pageSize:5,pageNum:1 })
      .then(res=>{
        this.teaList =  res.result.list
      })
      .catch(res=>{
        console.log(res);
      })
       articleList({ orgId: config.orgId,menu_pid:2037,menu_id:2040,pageSize:8,pageNum:1 })
      .then(res=>{
        this.courseList =  res.result.list
      })
      .catch(res=>{
        console.log(res);
      })
      // getArticles({
      //   relationId: config.relationId,
      //   menuId: 2038,
      //   relationType: 1,
      //   ps: 5,
      //   pn: 1,
      // })
      //   .then((res) => {
      //     // 返回数据
      //     this.bigNews = res.list[0] ? res.list[0] : {};
      //     this.schoolList = res.list.slice(1);
      //   })
      //   .catch((err) => {
      //     // 异常情况
      //     console.log(err);
      //   });
      // getArticles({
      //   relationId: config.relationId,
      //   menuId: 2039,
      //   relationType: 1,
      //   ps: 5,
      //   pn: 1,
      // })
      //   .then((res) => {
      //     // 返回数据
      //     this.teaList = res.list;
      //   })
      //   .catch((err) => {
      //     // 异常情况
      //     console.log(err);
      //   });
      // getArticles({
      //   relationId: config.relationId,
      //   menuId: 2040,
      //   relationType: 1,
      //   ps: 8,
      //   pn: 1,
      // })
      //   .then((res) => {
      //     // 返回数据
      //     this.courseList = res.list;
      //   })
      //   .catch((err) => {
      //     // 异常情况
      //     console.log(err);
      //   });
      // getArticles({
      //   relationId: config.relationId,
      //   menuId: 2000,
      //   relationType: 1,
      //   ps: 5,
      //   pn: 1,
      // })
      //   .then((res) => {
      //     // 返回数据
      //     this.bigNews1 = res.list[0] ? res.list[0] : {};
      //     this.activeList = res.list.slice(1);
      //   })
      //   .catch((err) => {
      //     // 异常情况
      //     console.log(err);
      //   });
    },
    getFirstPic: util.getFirstPic,
    replaceTag: util.replaceTag,
    getVideoPic: util.getVideoPic,
    getUnkownPic(url) {
      if (this.getFirstPic(url)) {
        return this.getFirstPic(url);
      } else {
        return this.getVideoPic(url);
      }
    },
    timeFormat(value) {
      return util.timeFormat(value, "yyyy-MM-dd");
    },
    doMore(menuId, type) {
      this.$router.push(`./news/${menuId}?type=${type}&label=2`);
    },
    viewNews(item) {
      console.log(item);
      this.$router.push(`./newsContent/${item.menu_id}/${item.id}?label=2`);
    },
  },
};
</script>
<style lang="scss" scoped>
.resultsShow{
  position: relative;
  z-index: 9;
}
.firstBgBox{
  position: absolute;
  width: 100%;
  height: 700px;
  top: 0;
  background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  overflow-x: hidden;
}
.newsBorder {
  width: 100%;
  height: 3px;
  background-color: #b92e32;
}
.default-img .iconfont {
  width: 36px;
  height: 36px;
  font-size: 36px;
}
h1 {
  position: relative;
  padding-bottom: 50px;
  .icon {
    display: inline-block;
    width: 143px;
    height: 56px;
    background-color: #b92e32;
    position: absolute;
  }
  .icon:before {
    position: absolute;
    bottom: 0px;
    right: -10px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #b92e32 transparent transparent #b92e32;
    border-style: solid;
    border-width: 28px 5px;
  }
  .icon1 {
    display: inline-block;
    width: 10px;
    height: 56px;
    background-color: #b92e32;
    position: absolute;
    left: 153px;
  }
  .icon1:before {
    position: absolute;
    bottom: 0px;
    right: 0px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #fae9e3 transparent transparent #fae9e3;
    border-style: solid;
    border-width: 28px 5px;
  }
  .icon1:after {
    position: absolute;
    bottom: 0px;
    right: -10px;
    content: " ";
    display: block;
    width: 0;
    height: 0;
    border-color: #b92e32 transparent transparent #b92e32;
    border-style: solid;
    border-width: 28px 5px;
  }
  .H1title {
    font-size: 28px;
    color: #ffffff;
    line-height: 36px;
    position: absolute;
    top: 10px;
    left: 20px;
    z-index: 2;
  }
  .H1title1 {
    font-size: 18px;
    color: #444444;
    line-height: 27px;
    position: absolute;
    left: 190px;
    top: 15px;
  }
  .viewMoreBtn {
    position: absolute;
    right: 0px;
    top: 13px;
  }
}
.white-background {
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
  padding-bottom: 0px;
}
.white-background1 {
  background-color: #fff;
  margin-top: 20px;
  padding: 20px;
}
.bigNews {
  padding-bottom: 20px;
}
.bigNews:hover {
  cursor: pointer;
}
.firstRow {
  margin-top: 40px;
}
.secondRow {
  .news-item1 {
    padding: 20px 0px;
    border-top: 1px dashed #b92e32;
  }
  .news-item1.first {
    padding-top: 0px;
    border-top: unset;
  }
  .cirBox {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 6px;
    background: #d9ae73;
    margin-top: -6px;
    vertical-align: middle;
  }
  .teaTitle {
    display: inline-block;
    font-size: 18px;
    color: #444444;
    letter-spacing: 0;
    line-height: 28px;
    font-weight: bold;
    margin-bottom: 12px;
    padding-left: 12px;
  }
  .teaContent {
    font-size: 14px;
    color: #969696;
    line-height: 21px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
  }
}
.thirdRow {
  margin-top: 50px;
  .course-item {
    background-color: #f5f5f5;
    .cover-wrapper{
      height: 153px;
      //width: 100%;
    }
    .cover {
      height: 153px;
       width: 100%;
    }
    .course-info {
      padding: 10px 10px 16px 10px;
      .title2 {
        font-size: 14px;
        color: #444444;
        line-height: 20px;
        font-weight: bold;
        height: 40px;
      }
      .time2 {
        margin-top: 10px;
        font-size: 12px;
        color: #969696;
        line-height: 18px;
      }
    }
  }
  .course-item:hover .title2 {
    color: #b92e32;
  }
  .course-item:hover {
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .topMargin {
    margin-top: 20px;
  }
}
.lastRow {
  margin-top: 50px;
}
.firstRowBox {
  min-height: 100%;
  background-color: #f5f5f5;
  background-image: url("~@/assets/images/kcsz/topBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  overflow-x: hidden;
  padding-bottom: 50px;
}
.secondRowBox {
  min-height: 100%;
  background-color: #f5f5f5;
  padding-bottom: 80px;
  h1 .icon1:before {
    border-color: #f5f5f5 transparent transparent #f5f5f5 !important;
  }
}
.title {
  font-size: 20px;
  height: 60px;
  color: #444444;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: bold;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  overflow: hidden;
}
.time {
  margin: 10px 0px 14px 0px;
  font-size: 14px;
  color: #969696;
  letter-spacing: 0;
  line-height: 20px;
}
.content {
  height: 216px;
  font-size: 14px;
  color: #444444;
  letter-spacing: 0;
  line-height: 24px;
  text-overflow: ellipsis;
  white-space: normal;
  overflow: hidden;
}
.news-image1 {
  height: 320px;
  width: 100%;
}
.news-item {
  padding: 20px 0px;
  border-top: 1px dashed #b92e32;
  .icontuwen {
    font-size: 18px;
    vertical-align: middle;
    color: #d9ae73;
    padding-right: 8px;
  }
  .time1 {
    font-size: 16px;
    color: #444444;
    letter-spacing: 0;
    line-height: 27px;
    padding-top: 8px;
    display: inline;
  }
  .title1 {
    font-size: 14px;
    color: #444444;
    letter-spacing: 0;
    line-height: 21px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
    width: 96%;
  }
}
.news-item:hover .title1 {
  color: #b92e32;
}
.news-item1:hover .teaTitle {
  color: #b92e32;
}
.news-item.first,
.news-item.second {
  border-top: unset;
}
.news-item:hover {
  cursor: pointer;
}
.news-item1:hover {
  cursor: pointer;
}
@media (max-width: 767px) {
  .resultsShow{
    position: unset;
  }
  h1 {
    .icon {
      width: 92px;
      height: 40px;
    }
    .icon::before {
      border-width: 20px 5px;
    }
    .icon1 {
      left: 103px;
      width: 10px;
      height: 40px;
    }
    .icon1::before {
      border-width: 20px 5px;
      border-color: #fff transparent transparent #fff !important;
      bottom:1px;
    }
    .icon1::after {
      border-width: 20px 5px;
    }
    .H1title {
      font-size: 18px;
      top: 3px;
      left: 10px;
    }
    .viewMoreBtn {
      top: 5px;
    }
  }
  .news-image1{
    height: 200px;
  }
  .firstRowBox {
    background-color: #fff;
    background-image: unset;
    padding-bottom: unset;
    .firstRow{
      margin-top: 20px;
    }
  }
  .secondRowBox {
    background-color: #fff;
    background-image: unset;
  }
  .white-background {
    padding: 0;
    margin-top: 6px;
  }
  .title {
    font-size: 16px;
    line-height: 24px;
    margin-top: 12px;
    height: 48px;
  }
  .time {
    margin: 8px 0px;
  }
  .content {
    height: 48px;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    overflow: hidden;
  }
  .bigNews {
    padding-bottom: 16px;
  }
  .news-item {
    padding: 16px 0px;
  }
  .news-item.second {
    border-top: 1px dashed #b92e32;
  }
  .bgBox1 {
    display: block !important;
    width: 100vw;
    height: 15px;
    margin-left: -15px;
    background-color: #f8f8f8;
  }
  .secondRowBox {
    padding: 16px 0px 30px 0px;
    h1 .icon1::before {
      border-color: #fff transparent transparent #fff !important;
    }
  }
  .secondRow {
    .cirBox {
      margin-top: 0px;
    }
    .teaTitle {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 9px;
      padding-left: 10px;
    }
    .news-item1 {
      padding: 14px 0px;
    }
    .teaContent {
      font-size: 12px;
      line-height: 18px;
    }
  }
  .thirdRow {
    margin-top: 16px;
    .course-item {
      background-color: unset;
      .cover-wrapper{
        height: 93px;
      }
      .cover {
        height: 93px;
      }
      .course-info {
        padding: 10px 0px 20px 0px;
        .time2 {
          margin-top: 8px;
        }
      }
    }
    .topMargin{
      margin-top: 0px;
    }
  }
  .white-background1 {
    margin-top: 0px;
    padding: 6px 0px 4px 0px;
  }
  .lastRow{
    margin-top: 16px;
  }
}
</style>